import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ServerProvider } from '../../providers/server/server';
import { AlertController } from 'ionic-angular';
import { LoadingController, Loading } from 'ionic-angular';
import { ItemSliding } from 'ionic-angular';
import {TransactionPage} from '../transaction/transaction';

@Component({
    selector: 'page-account',
    templateUrl: 'account.html',
})
export class AccountPage {
    user_id: String;
    accounts = []
    loader: Loading

    constructor(public navCtrl: NavController, public navParams: NavParams,
        public server: ServerProvider, private alertCtrl: AlertController,
        public loadingCtrl: LoadingController) {
        this.user_id = JSON.parse(window.localStorage['account'])["currentUser"]["id"];

        this.loader = this.loadingCtrl.create({
            content: "Bitte warten...",
            duration: 5000
        });
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad AccountPage');

        let loader = this.loadingCtrl.create({
            content: "Bitte warten",
            duration: 5000
        });
        loader.present()
        this.server.getAccounts(this.user_id).subscribe(
            data => {
                this.accounts = data.json()
                loader.dismiss()
            },
            error => {
                loader.dismiss()
            }
        );
    }

    new_account() {
        let alert = this.alertCtrl.create({
            title: 'Konto erstellen',
            subTitle: "Name des neuen Kontos",
            inputs: [
                {
                    name: 'account_name',
                    placeholder: 'Name des Kontos'
                },
            ],
            buttons: [
                {
                    text: 'Schließen',
                    role: 'cancel',
                    handler: data => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Erstellen',
                    handler: data => {
                        if (!data.account_name)
                            return false;


                        this.loader.present();

                        this.server.createAccount(this.user_id, data.account_name).subscribe(
                            data => {
                                this.accounts.push(data.json())
                                this.loader.dismiss()
                            },
                            error => {
                                this.loader.dismiss()
                            }
                        )
                        return true;
                    }
                }
            ]
        });
        alert.present();
    }


    delete_account(account_id: String, idx: number, slidingItem: ItemSliding) {
        let alert = this.alertCtrl.create({
            title: 'Account löschen',
            message: 'Sind Sie sicher, dass Sie den Account löschen möchten?',
            buttons: [
                {
                    text: 'Abbrechen',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Löschen',
                    handler: () => {
                        console.log('Clicked on delete button');
                        this.accounts.splice(idx, 1);
                        this.server.deleteAccount(this.user_id, account_id).subscribe(
                            data => {
                                console.log("Deletion successful")
                            },
                            error => {
                                console.log("Deletion failed")
                            }
                        )
                    }
                }
            ]
        });
        alert.present();
    }

    edit_account(account: any, idx: number, slidingItem: ItemSliding) {
        let alert = this.alertCtrl.create({
            title: 'Konto bearbeiten',
            subTitle: "Bearbeiten Sie den Namen des Kontos",
            inputs: [
                {
                    name: 'account_name',
                    placeholder: 'Name des Kontos',
                    value: account.name
                },
            ],
            buttons: [
                {
                    text: 'Schließen',
                    role: 'cancel',
                    handler: data => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Bearbeiten',
                    handler: data => {
                        if (!data.account_name)
                            return false;

                        slidingItem.close();

                        this.loader.present();
                        this.server.editAccount(this.user_id, account.id, data.account_name).subscribe(
                            response => {
                                this.accounts[idx].name = data.account_name
                                this.loader.dismiss();
                            },
                            error => {
                                this.loader.dismiss();
                            }
                        )
                        return true;
                    }
                }
            ]
        });
        alert.present();
    }

    new_transaction(account_id: String, slidingItem: ItemSliding) {
        /*
        $state.go('transactions_add', {"userId":$stateParams.userId, "accountId":account_id})
        $ionicListDelegate.closeOptionButtons();
        */
        slidingItem.close();
    }

    goto_transactions(account_id: String) {
        console.log("Clicked goto transactions")
        this.navCtrl.push(TransactionPage, {"user_id": this.user_id, "account_id": account_id});
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/account.ts